import styled from "styled-components";
import { useFilterContext } from "../context/filter_context";
import { Button } from "../styles/Button";

const FilterSection = () => {
  const {
    filters: { text, category},
    updateFilterValue,
    all_products,
    clearFilters,
  } = useFilterContext();

  // get the unique values of each property
  const getUniqueData = (data, attr) => {
    let newVal = data.map((curElem) => {
      return curElem[attr];
    });

    return (newVal = ["all", ...new Set(newVal)]);
  };

  const categoryData = getUniqueData(all_products, "category");
  const companyData = getUniqueData(all_products, "company");


  return (
    <Wrapper>
      <div className="filter-search">
        <form onSubmit={(e) => e.preventDefault()}>
          <input
            type="text"
            name="text"
            placeholder="Search"
            value={text}
            onChange={updateFilterValue}
          />
        </form>
      </div>

      <div className="filter-category">
        <h3>Model Type</h3>
        <div>
          {categoryData.map((curElem, index) => {
  if (curElem === "all") return null;
  return (
    <div key={index}>
      <input
        type="checkbox"
        id={`category-${index}`}
        name="category"
        value={curElem}
        checked={category.includes(curElem)}
        onChange={updateFilterValue}
      />
      <label htmlFor={`category-${index}`}>{curElem}</label>
    </div>
  );
})}

        </div>
      </div>

      <div className="filter-company">
        <h3>Industry Sector</h3>

        <form action="#">
          <select
            name="company"
            id="company"
            className="filter-company--select"
            onClick={updateFilterValue}>
            {companyData.map((curElem, index) => {
              return (
                <option key={index} value={curElem} name="company">
                  {curElem}
                </option>
              );
            })}
          </select>
        </form>
      </div>
      <div className="filter-clear">
        <Button className="btn" onClick={clearFilters}>
          Clear Filters
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 5rem;
  display: flex;
  flex-direction: column;
  margin: 50px auto;
  gap: 3rem;
  background-color: #ecf0f1;

  h3 {
    padding: 2rem 0;
    font-size: bold;
  }

  .filter-search {
    input {
      padding: 0.6rem 1rem;
      width: 80%;
    }
  }

.filter-category {
  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    div {
      display: flex;
      flex-direction: row; /* Add this line */
      align-items: center;
      gap: 1 rem;

      label {
        text-transform: capitalize;
        cursor: pointer;
        font-size: 1.8rem;

        &:hover {
          color: ${({ theme }) => theme.colors.btn};
        }
      }

      input[type="checkbox"] {
        cursor: pointer;
        margin-left: 1rem;
      }
    }

    .active {
      color: ${({ theme }) => theme.colors.btn};
    }
  }
}


  .filter-company--select {
    padding: 0.3rem 1.2rem;
    font-size: 1.6rem;
    color: ${({ theme }) => theme.colors.text};
    text-transform: capitalize;
  }

  .active {
    opacity: 1;
  }

  .checkStyle {
    font-size: 1rem;
    color: #fff;
  }

  .filter-clear .btn {
    background-color: #ec7063;
    color: #000;
  }
`;

export default FilterSection;
